import React from "react";
import PropTypes from "prop-types";
import Link from "../../elements/link";

const FilterSlide = ({ slide, isActive }) => {
  return (
    <Link
      url={slide.url}
      className={`slide slide--${isActive ? "active" : "inactive"}`}
    >
      <div
        className={`slide__image slide__image--${
          isActive ? "active" : "inactive"
        }`}
        style={{
          backgroundImage: `url(${slide.image})`,
        }}
      />
      <div
        className={`slide__overlay slide__overlay--${
          isActive ? "active" : "inactive"
        }`}
      >
        <div
          className={`slide__logo`}
          style={{
            backgroundImage: `url(${slide.logo})`,
          }}
        />
      </div>
    </Link>
  );
};

FilterSlide.propTypes = {
  slide: PropTypes.shape({
    image: PropTypes.string,
    logo: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default FilterSlide;
